module.exports = __webpack_public_path__ + "img/default-profile.b80a382d.png";